import { render, staticRenderFns } from "./offers-page.vue?vue&type=template&id=71f3a010"
import script from "./offers-page.vue?vue&type=script&lang=js"
export * from "./offers-page.vue?vue&type=script&lang=js"
import style0 from "./offers-page.vue?vue&type=style&index=0&id=71f3a010&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports